import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Container from "../../components/Container/Container";
import css from "./ListingDetailsPage.module.scss";
import Modal from "react-modal";
import VenueListingDetails from "../../components/VenueListingDetails/VenueListingDetails";
import ShowListingDetails from "../../components/ShowListingDetails/ShowListingDetails";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LISTING_VENUES, breakpointsLDP } from "../../constants/data";
import { fetchCurrentListing } from "../../redux/reducers/listingSlice";
import IconCollection from "../../components/IconCollection/IconCollection";
import { Swiper, SwiperSlide } from "swiper/react";


// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";

// const list

const ListingDetailsPage = () => {
  const { id, table } = useParams() ?? {};
  const dispatch = useDispatch();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [listingData, setListingData] = useState({})
  useEffect(() => {
    const fetchData = async () => {
      const body = {
        id: id,
        table: table
      }
      try {
        const response = await dispatch(fetchCurrentListing(body))
        setListingData(response?.payload?.data)
      } catch (err) {
        console.log('err', err)
      }
    }
    fetchData();
  }, [dispatch, id, table])

  const { cover_image, additional_media, poster } = listingData || {};

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const isMobile = typeof window !== "undefined" && window.innerWidth < 767;
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      width: isMobile ? "90%" : "95%",
      transform: "translate(-50%, -50%)",
      padding: isMobile ? "36px 12px 16px" : "48px 24px 24px",
      maxHeight: "93vh",
      // maxWidth: isMobile ? "341px" : "1260px",
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <div>
      <Header />
      <Container>
        <div className={css.detailPageWrapper}>
          <div className={css.listingGallery}>
            <div className={css.listingGalleryWrapper}>
              <div className={css.firstColumn}>
                <img src={(cover_image || poster)?.url} alt={(cover_image || poster)?.key} />
              </div>
              <div className={css.secondColumn}>
                {additional_media?.length > 0 && additional_media?.slice(0, 2).map(st => {
                  return (
                    <div key={st.key} className={css.halfHeight}>
                      <embed src={st.url} alt={st.key} />
                    </div>
                  )
                })}
              </div>
              <div className={css.thirdColumn}>
                {additional_media?.length > 0 && additional_media?.slice(2, 4).map(st => {
                  return (
                    <div key={st.key} className={css.halfHeight}>
                      <embed src={st.url} alt={st.key} />
                    </div>
                  )
                })}
              </div>
            </div>
            <button onClick={openModal} className={css.allViewButton}>
              View all photos
            </button>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Example Modal"
              className={css.allImageModal}
            >
              <span className={css.closeModal} onClick={closeModal}><IconCollection name="CLOSE_ICON" /></span>
              <div className={css.modalImages}>
                <Swiper
                  breakpoints={breakpointsLDP}
                  navigation={true}
                  cssMode={true}
                  pagination={{
                    dynamicBullets: true,
                  }}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                  slidesPerView={3}
                >
                  <SwiperSlide>
                    <div className={css.modalImage}>
                      <embed src={(cover_image || poster)?.url} alt={(cover_image || poster)?.key} />
                    </div>
                  </SwiperSlide>
                  {additional_media?.length > 0 && additional_media.map(st =>
                  <SwiperSlide key={st.key}>
                      <div className={css.modalImage}>
                        <embed src={st.url} alt={st.url} />
                      </div>
                  </SwiperSlide>
                  )}

                </Swiper>
              </div>
            </Modal>
          </div>

          {table === LISTING_VENUES ?
            <VenueListingDetails />
            :
            <ShowListingDetails listingData={listingData} />
          }
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default ListingDetailsPage;
